import React from 'react'
import styled from 'styled-components'
import SEO from 'src/components/seo'
import { Input, Divider, Label, Message } from 'semantic-ui-react'
import 'semantic-ui-less/semantic.less'
import InputWrapper from 'src/components/InputWrapper'
import Paper from 'src/components/Paper'
import Title from 'src/components/Title'
import SubTitle from 'src/components/SubTitle'
import SectionTitle from 'src/components/SectionTitle'
import ConvertButton from 'src/components/ConvertButton'
import GiftButton from 'src/components/GiftButton'
import Tabs from 'src/components/tabs'
import HeaderBackground from 'src/images/header-background.svg'
import SpHeaderBackground from 'src/images/sp-header-background.svg'
import { AppProvider, AppContext } from 'src/context/AppContext'
import Destination from 'src/components/Destination'
import ShareButtons from 'src/components/ShareButtons'
import { createGlobalStyle, ThemeProvider } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  * {
    font-family: 'YuGothic','Yu Gothic','Hiragino Kaku Gothic ProN','ヒラギノ角ゴ ProN W3','メイリオ', 'Meiryo','ＭＳ ゴシック',sans-serif;
  }
`

class IndexPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = { copied: false }
  }

  copyToClipboard = e => {
    this.setState({ copied: true })
    this.copyInput.select()
    document.execCommand('copy')
    e.target.focus()
    setTimeout(() => {
      this.setState({ copied: false })
    }, 2600)
  }

  render() {
    const { copied } = this.state
    return (
      <ThemeProvider theme={{}}>
        <GlobalStyle />
        <AppProvider>
          <AppContext.Consumer>
            {({ state, actions }) => (
              <div>
                <SEO />
                <StyledHeaderBackground />
                <StyledSpHeaderBackground />
                <GiftButtonWrapper>
                  <GiftButton />
                </GiftButtonWrapper>
                <Paper>
                  <div>
                    <Title>Slack remind creator</Title>
                  </div>
                  <div>
                    <SubTitle>
                      <Span>このツールはSlackのremindコマンドを</Span>
                      簡単に生成できるツールです。
                    </SubTitle>
                  </div>
                  <InputContainer>
                    <InputWrapper>
                      <Destination />
                    </InputWrapper>
                    <InputWrapper>
                      <SectionTitle>メッセージ</SectionTitle>
                      <StyledInput
                        name={'message'}
                        type={'text'}
                        error={state.submitted && !state.message}
                        placeholder={'what'}
                        value={state.message}
                        onChange={actions.onChangeInput}
                      />
                    </InputWrapper>
                    <InputWrapper>
                      <SectionTitle>リマインド</SectionTitle>
                      <Tabs />
                    </InputWrapper>
                    <ConvertButtonWrapper>
                      <ConvertButton color={'red'} onClick={actions.onConvert}>
                        変換
                      </ConvertButton>
                    </ConvertButtonWrapper>
                    {state.errors.length !== 0 && (
                      <ErrorMessageWrapper>
                        <Message error list={state.errors} />
                      </ErrorMessageWrapper>
                    )}
                  </InputContainer>
                  <Divider />
                  <ResultContainer>
                    <p>Slack command</p>
                    <CopyInput
                      action={{
                        color: 'teal',
                        labelPosition: 'right',
                        icon: 'copy',
                        content: 'Copy',
                        onClick: this.copyToClipboard
                      }}
                      ref={copyInput => (this.copyInput = copyInput)}
                      value={state.command}
                    />
                    {copied && (
                      <Label pointing color='green'>
                        クリップボードにコピーしました。
                      </Label>
                    )}
                  </ResultContainer>
                </Paper>
                <ShareButtons />
              </div>
            )}
          </AppContext.Consumer>
          <Footer>
            ©{' '}
            <FooterLink href='https://twitter.com/ichiki_sato'>
              Ichiki
            </FooterLink>{' '}
            &{' '}
            <FooterLink href='https://twitter.com/haluna_san'>
              Haluna
            </FooterLink>{' '}
            2019
          </Footer>
        </AppProvider>
      </ThemeProvider>
    )
  }
}

export default IndexPage

const InputContainer = styled.div`
  width: 60%;
  min-width: 460px;
  margin: 0 auto;

  @media (max-width: 830px) {
    width: 100%;
    min-width: 100%;
  }
`

const ResultContainer = styled.div`
  width: 90%;
  height: 100px;
  min-width: 600px;
  margin: 40px auto 0 auto;

  @media (max-width: 830px) {
    width: 100%;
    min-width: 100%;
  }
`

const StyledInput = styled(Input)`
  && {
    width: 100%;
  }
`

const CopyInput = styled(Input)`
  && {
    width: 100%;
  }
`

const ConvertButtonWrapper = styled.div`
  text-align: center;
  margin-top: 40px;
`

const StyledHeaderBackground = styled(HeaderBackground)`
  && {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: -1;
    width: 100%;
    height: auto;
  }
`

const StyledSpHeaderBackground = styled(SpHeaderBackground)`
  && {
    display: none;

    @media (max-width: 830px) {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      z-index: -1;
      width: 100%;
      height: auto;
      display: block;
    }
  }
`

const Footer = styled.footer`
  color: #611f69;
  font-size: 12px;
  text-align: center;
  padding: 18px 0;

  @media (max-width: 830px) {
    padding: 12px 0;
  }
`

const ErrorMessageWrapper = styled.div`
  margin: 20px 0;
`

const Span = styled.span`
  @media (max-width: 830px) {
    display: block;
  }
`

const FooterLink = styled.a`
  color: inherit;

  &:hover {
    color: inherit;
    border-bottom: solid 1px #611f69;
  }
`

const GiftButtonWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`
